<template>
    <div class="updateRequiredWrap d-flex flex-column justify-content-center align-item-center">
        <b-card title="Update Required" sub-title="Oops!" class="mx-2">
            <b-card-text>
            This version of VU Bingo has been outdated please update !
            </b-card-text>

            <b-button @click="update()" variant="warning">UPDATE</b-button>
        </b-card>
    </div>
</template>
<script>
import config from '@/config'
export default {
    methods:{
        update(){
            openNewWindow(config.playStoreUrl, '_system');
        }
    }
}
</script>